import Icon, { IconProps } from "./Icon";

const IconGoogle = ({
  description, height, width,
}: Omit<IconProps, "filename">) => <Icon filename="google.svg" description={description} height={height} width={width} />;

export default IconGoogle;
